<template>
  <div>
    <h2>Подписание сверка актов с 1С</h2>

    <div class="row g-3" v-if="hasAccess([...findirRoles, ...accountantRoles])">
    <div class="row col-md-7">
      <div class="el-input-group">
        <label for="accountingYear" class="form-label col-md-3">Расчетный год</label>
        <div class="col-md-9">
          <div class="input-group">
            <input type="number" min='2024' step="1" class="form-control" id="accountingYear" required v-model="accountingYear">
          </div>
        </div>
      </div>
    </div>

<!--      <div class="row col-md-7">-->
<!--        <div class="el-input-group">-->
<!--          <label for="katoCode" class="form-label col-md-3">Населенный пункт</label>-->
<!--          <div class="col-md-9">-->
<!--            <div class="input-group">-->
<!--              <multiselect-->
<!--                  v-model="kato"-->
<!--                  :options="katoList"-->
<!--                  :searchable="true"-->
<!--                  :closeOnSelect="true"-->
<!--                  :custom-label="formattedKatoLabel"-->
<!--                  placeholder="Выберите Като"-->
<!--                  :multiple="false"-->
<!--                  :clear-on-select="true"-->
<!--              />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

    <div class="row col-md-7">
      <div class="el-input-group">
        <label for="binList" class="form-label col-md-3">Список БИНов (пишите через запятую или один за другим)</label>
        <div class="col-md-9">
          <div class="input-group">
              <textarea id="binList" cols="30" rows="10" class="form-control" v-model="binList"
                        placeholder="1234567, 1234567, ...
или
1234567
1234567
..."></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="row col-md-7">
      <div class="el-input-group">
        <label for="kindergartenHeadSignStatus" class="form-label col-md-3">По статусу подписи директоров ДО</label>
        <div class="col-md-9">
          <div class="input-group">
            <select v-model="kindergartenHeadSignStatus" id="kindergartenHeadSignStatus" class="form-control">
              <option value="">Выберите</option>
              <option value="NOT_SIGNED">Не подписан</option>
              <option value="SIGNED">Подписан</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row col-md-7">
      <div class="el-input-group">
        <label for="findirSignStatus" class="form-label col-md-3">По статусу подписи фин. дир.</label>
        <div class="col-md-9">
          <div class="input-group">
            <select v-model="findirSignStatus" id="findirSignStatus" class="form-control">
              <option value="">Выберите</option>
              <option value="NOT_SIGNED">Не подписан</option>
              <option value="SIGNED">Подписан</option>
            </select>
          </div>
        </div>
      </div>
    </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <button class="btn btn-primary" @click="fetchKindergarten1CActReconciliationReports">Поиск</button>
          <button v-if="!isLoading" class="btn btn-warning" @click="clearSearchParam()">Сбросить фильтр</button>
          <button v-else class="btn btn-loading" disabled>Загрузка</button>
        </div>
      </div>

    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>
    <b-pagination v-model="currentPage" :total-rows="totalCount" :per-page="pageSize"></b-pagination>
    <el-table :data="kindergarten1cActReconciliationReports" style="width: 100%" v-loading="isLoading">
      <el-table-column
          type="index"
          label="#"
          width="50">
      </el-table-column>
      <el-table-column
          label="Расчетный год">
        <template #default="scope">
          <span>{{ scope.row.report.accountingYear }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="БИН"
      >
        <template #default="scope">
          <span>{{ scope.row.report.bin }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="Название файла">
        <template #default="scope">
          <a
              @click="handleDownload(scope.row.report.uuid, scope.row.report.fileName)"
              :class="{ 'active-link': scope.row.report.reportStatus === 'GENERATED', 'error-link': scope.row.report.reportStatus === 'ERROR' }"
          >
            {{ scope.row.report.fileName }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="Статус подписи директора ДО">
        <template #default="scope">
          <span v-if="scope.row.kindergartenHeadSignStatus === 'SIGNED'">Подписан {{ scope.row.kindergartenHeadSignDateTime }}</span>
          <div v-else-if="hasAccess([...kindergartenHeadRoles]) && scope.row.kindergartenHeadSignStatus === 'NOT_SIGNED'">
            <el-button
                v-if="!isSaving"
                type="primary"
                @click="onClickSignDocument(scope.row.report.uuid)">
              Подписать
            </el-button>
            <el-button v-else disabled>Загрузка...</el-button>
          </div>
          <span v-else-if="hasAccess([...findirRoles,...accountantRoles]) && scope.row.kindergartenHeadSignStatus === 'NOT_SIGNED'">
            Не подписан
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Статус проверки бухгалтера">
        <template #default="scope">
          <el-text v-if="scope.row.hasAccountantChecked" type="success">Проверено</el-text>
          <div v-else>
            <el-button v-if="hasAccess([...accountantRoles])" type="success" plain :loading="isLoading" @click="saveAccountantAccept(scope.row.id)">Проверено</el-button>
            <el-text v-else type="info">Не Проверено</el-text>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Статус подписи Фин. Дир.">
        <template #default="scope">
          <span v-if="scope.row.finDirSignStatus === 'SIGNED'">Подписан {{ scope.row.finDirSignDateTime }}</span>
          <div v-else-if="hasAccess([...findirRoles]) && scope.row.finDirSignStatus === 'NOT_SIGNED'">
            <el-button
                v-if="!isSaving"
                type="primary"
                @click="onClickSignDocument(scope.row.report.uuid)">
              Подписать
            </el-button>
            <el-button v-else disabled>Загрузка...</el-button>
          </div>
          <span v-else-if="hasAccess([...kindergartenHeadRoles]) && scope.row.finDirSignStatus === 'NOT_SIGNED'">
            Не подписан
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script lang="ts">
import {defineComponent, onMounted, ref, watch} from "vue";
import authService from "@/services/authService";
import {
  downloadFileBytes,
  downloadReportFile,
  kindergarten1cActReconciliationReportList, setSaveAccountantAccept
} from "@/services/reportService";
import {convertFileBytesToBase64} from "@/services/fileService";
import signService from "@/services/ncaLayerService";
import {sign1cActReconciliationDocument, signDocument} from "@/services/signService";
import {ElMessage} from "element-plus";
import {Kindergarten1cActReconciliation} from "@/types/report";
import {PageResponse} from "@/types/pageResponse";
import {SearchParam} from "@/types/searchParam";
import Multiselect from "vue-multiselect";
import {Kato} from "@/types/kindergarten";
import cacheService from "@/services/cacheService";

export default defineComponent({
  name: "Kindergarten1cActReconciliationView",
  components: {Multiselect},
  setup() {

    onMounted(() => {
      fetchKindergarten1CActReconciliationReports();
      fetchCachedData();
    });

    const {signCallback} = signService;
    watch(() => signCallback.callback, (newVal) => {
      if (newVal) {
        newVal(signCallback.result);
      }
    });
    signService.init();

    const kato = ref<Kato | null>(null);
    const accountingYear = ref<number | null>(new Date().getFullYear());
    const binList = ref<string | null>(null);
    const kindergartenHeadSignStatus = ref<string | null>(null);
    const findirSignStatus = ref<string | null>(null);
    const searchParam = ref<SearchParam>();
    const katoList = ref<Kato[]>([]);

    const fetchCachedData = async () => {
      katoList.value = await cacheService.useKatoStore().fetchKato();
    };

    const totalCount = ref(0);
    const currentPage = ref(1);
    let page = 1;
    const pageSize = 10;

    const isLoading = ref(false);

    const kindergarten1cActReconciliationReports = ref<Kindergarten1cActReconciliation[]>([]);
    const response = ref<PageResponse<Kindergarten1cActReconciliation>>();

    const setSearchParam = () => {
      const filter : Record<string, any> = {};
      filter["accountingYear"] = accountingYear.value;
      filter["binList"] = binList.value;
      filter["kindergartenHeadSignStatus"] = kindergartenHeadSignStatus.value;
      filter["finDirSignStatus"] = findirSignStatus.value;
      filter["katoCode"] = kato.value?.code;
      searchParam.value = {
        countInPage: 1000000,
        partNumber: 0,
        sort: {},
        filter
      }
      return searchParam.value;
    }

    const fetchKindergarten1CActReconciliationReports = async () => {
      isLoading.value = true;
      response.value = await kindergarten1cActReconciliationReportList(setSearchParam())
      kindergarten1cActReconciliationReports.value = response.value.content;
      totalCount.value = response.value.totalElements;
      isLoading.value = false;
    }

    const saveAccountantAccept = async (id: number) => {
      isLoading.value = true;
      var res = await setSaveAccountantAccept(id);
      const report = kindergarten1cActReconciliationReports.value.find(r => r.id === id);
      if (report) {
        report.hasAccountantChecked = true;
      }
      isLoading.value = false;
    }

    const clearSearchParam = () => {
      accountingYear.value = new Date().getFullYear();
      binList.value = null;
      findirSignStatus.value = null;
      kindergartenHeadSignStatus.value = null;
      kato.value = null;
    }

    const hasAccess = authService.hasAccess;
    const kindergartenHeadRoles: string[] = authService.getKindergartenHeadRoles();
    const findirRoles: string[] = authService.getFinDirRoles();
    const accountantRoles: string[] = authService.getAccountantRoles();

    const handleDownload = async (fileId: string, fileName: string) => {
      try {
        const token = localStorage.getItem("access_token");
        if (token) {
          await downloadReportFile(token, fileId, fileName);
        }
      } catch (error) {
        console.error("Ошибка при скачивании файла:", error);
      }
    };

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    return {
      kato,
      binList,
      accountingYear,
      kindergartenHeadSignStatus,
      findirSignStatus,
      totalCount,
      currentPage,
      page,
      pageSize,
      kindergartenHeadRoles,
      findirRoles,
      accountantRoles,
      isLoading,
      kindergarten1cActReconciliationReports,
      katoList,
      hasAccess,
      handleDownload,
      fetchKindergarten1CActReconciliationReports,
      clearSearchParam,
      signService,
      formattedKatoLabel,
      saveAccountantAccept
    }
  },
  data() {
    return {
      fileId: "",
      isSaving: false,
    }
  },
  methods: {
    async onClickSignDocument(fileId: string) {
      this.isSaving = true;
      this.fileId = fileId;
      const token = localStorage.getItem("access_token");
      if (token) {
        const fileBytes = await downloadFileBytes(token, fileId);
        const base64ToSign = await convertFileBytesToBase64(fileBytes);
        this.signService.createCMSSignatureFromBase64(this.getSelectedStorage(), 'SIGNATURE', base64ToSign, false, this.onSignDocumentCallback);
      }
    },
    getSelectedStorage() {
      return localStorage.getItem('selectedStorage') || 'PKCS12';
    },
    onSignDocumentCallback: async function (response: any) {
      if (response.status) {
        const cms = response.result;
        const token = localStorage.getItem("access_token");
        if (token) {
          try {
            await sign1cActReconciliationDocument(token, this.fileId, cms).then();
            ElMessage.success("Документ успешно подписан");
            this.isSaving = false;
            await this.fetchKindergarten1CActReconciliationReports();
          } catch (error: any) {
            this.isSaving = false;
            if (error && error.message) {
              console.error('Error message:', error?.message);
              ElMessage.error(error.message);
            } else {
              console.error('Unexpected error:', error);
            }
          }
        }
      }
    }
  }
});
</script>

<style scoped></style>